import $ from 'jquery'

export function logAdPageView (element) {
  const $banner = $(element).closest('.banner-link')
  if (!$banner.length) return

  const token = $banner.data('token')
  if (!token) return

  $.ajax({
    url: '/page_events',
    method: 'post',
    data: {
      token,
      event_type: 'page_view',
      host: window.location.host,
      pathname: window.location.pathname,
      query_parameters: window.location.search
    }
  })
}

// Called once on page load to bind click handler
export function initPageEvents () {
  // namespaced so we don't double-bind across Turbo visits
  $(document)
    .off('click.pageEvents', '.banner-link')
    .on('click.pageEvents', '.banner-link', function () {
      const token = $(this).data('token')
      if (!token) return

      $.ajax({
        url: '/page_events',
        method: 'post',
        data: {
          token,
          event_type: 'ad_unit_click',
          host: window.location.host,
          pathname: window.location.pathname,
          query_parameters: window.location.search
        }
      })
    })
}
